/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-expressions */
// @ts-check

import $ from 'jquery';
import angular from 'angular';

/**
 * rcm is a base library to help with the issues with Angular when Angular is not
 *   in charge of all domain changes.  It is NOT a perfect solution, so use these
 *   only as required.
 *   - helps with exposing Angular methods and properties
 *   - helps with AJAX loading of Angular scripts
 *   - helps with loading Angular modules without using bootstrap
 *   - helps with console.log issues in IE 8 and lower
 *
 * @this {import('./types').RcmCore}
 */
const RcmCore = function () {
  const self = this;

  self.moduleDepenencies = [];

  self.safeApply = null;
  self.rootScope = null;
  self.angularSafeApply = null;
  self.angularCompile = null;
  self.app = null;
  self.compile = null;
  self.scope = null;

  /**
   * config - Exposes a standard way of sharing config data
   *
   * @type {{}}
   */
  self.config = {};

  /**
   * get Config Value
   *
   * @param configKey
   * @param defaultValue
   * @returns {*}
   */
  self.getConfigValue = function (configKey, defaultValue) {
    if (self.config[configKey]) {
      return self.config[configKey];
    }

    return defaultValue;
  };

  /**
   * @param moduleName AngularJS Module name
   * EXAMPLE:
   * {
   *   name: 'e',
   *   files: ['/modules/my/script.js']
   * }
   */
  self.addAngularModule = function (moduleName, _) {
    if (self.hasModule(moduleName)) {
      return;
    }

    if (!self.app) {
      self.pushModuleName(moduleName);
      return;
    }

    console.error('Module: ' + moduleName + ' registered too late.');
  };

  /**
   *
   * @param moduleConfigs
   * EXAMPLE: [name]: [lazyLoadConfig]
   * {
   *  'myModuleName': {files: ['/modules/my/script.js']}
   * }
   */
  self.addAngularModules = function (moduleConfigs) {
    // eslint-disable-next-line guard-for-in
    for (const moduleName in moduleConfigs) {
      self.addAngularModule(moduleName, moduleConfigs[moduleName]);
    }
  };

  /**
   *
   * @param moduleName
   */
  self.pushModuleName = function (moduleName) {
    if (!self.hasModule(moduleName)) {
      self.moduleDepenencies.push(moduleName);
    }
  };

  /**
   *
   * @param moduleName
   * @returns {boolean}
   */
  self.hasModule = function (moduleName) {
    return self.moduleDepenencies.indexOf(moduleName) > -1;
  };

  /**
   *
   * @param document
   */
  self.init = function (document) {
    const angularModule = angular.module('rcm', self.moduleDepenencies);

    angular.element(document).ready(function () {
      angular.bootstrap(document, ['rcm']);

      self.app = angularModule;

      self.compile = angular.element(document).injector().get('$compile');

      self.scope = angular.element(document).scope();

      self.rootScope = angular.element(document).injector().get('$rootScope');

      self.rootScope.safeApply = function (fn) {
        const phase = self.rootScope.$$phase;
        if (phase == '$apply' || phase == '$digest') {
          if (fn && typeof fn === 'function') {
            fn();
          }
        } else {
          self.rootScope.$apply(fn);
        }
      };

      self.safeApply = function (scope, fn) {
        const phase = scope.$root.$$phase;
        if (phase == '$apply' || phase == '$digest') {
          if (fn && typeof fn === 'function') {
            fn();
          }
        } else {
          scope.$apply(fn);
        }
      };

      self.angularSafeApply = function (fn) {
        self.rootScope.safeApply(fn);
      };

      self.angularCompile = function (elm, fn) {
        console.warn('rcm.angularCompile can cause problems for other angular directives!');

        const content = elm.contents();

        angular
          .element(document)
          .injector()
          // @ts-ignore
          .invoke([
            '$compile',
            function ($compile) {
              const scope = angular.element(content).scope();
              $compile(content)(scope);
              self.safeApply(scope, fn);
              // self.rootScope.safeApply(fn);
            },
          ]);
      };
    });
  };

  /**
   * @deprecated Use RcmPluginModel.getPluginContainerSelector()
   * Or Use RcmAdminPlugin.model.getPluginContainerSelector() AKA: pluginHandler.model.getPluginContainerSelector()
   *
   * From old scripts
   * @param instanceId
   * @returns {string}
   */
  self.getPluginContainerSelector = function (instanceId) {
    return '[data-rcmPluginInstanceId="' + instanceId + '"] .rcmPluginContainer';
  };

  /**
   * @deprecated Use RcmPluginModel.getElm
   * Or Use RcmAdminPlugin.getElm() AKA: pluginHandler.getElm()
   * From old scripts
   * @param instanceId
   * @returns {*|jQuery|HTMLElement}
   */
  self.getPluginContainer = function (instanceId) {
    return $(self.getPluginContainerSelector(instanceId));
  };

  self.init(document);
};

window.rcm = new RcmCore();
